// Backend is picked at runtime from the host the shell is served on, so one
// build serves both prod (app.kinesis.org) and the alpha pentest/DAST mirror
// (alpha.kinesis.org) — no per-environment publish.
const backend = window.location.hostname.endsWith('alpha.kinesis.org')
  ? 'https://authentication-api.alpha.kinesis.org'
  : 'https://authentication-api.app.kinesis.org';

const server =
  import.meta.env.MODE === 'development' ? 'http://localhost:3000' : backend;

export { server };
